import { useParams } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { KitsWorkspace } from '../components/evaluation/KitsWorkspace';

/**
 * ADMIN-04 — one interview kit, open under the strip of kits (admin redesign batch 2, Option A). `new` starts a blank one; an
 * older version's id opens that version read-only. Saving writes the next version; rounds keep the one they picked.
 */
export function InterviewKitEditorPage(): ReactNode {
  const { kitId } = useParams({ from: '/app-layout/admin/interview-kits/$kitId' });
  return <KitsWorkspace selectedId={kitId} />;
}
